import { queryCachePersisters } from "@-/dev.improve.haniverse.lib.storage/query-cache-persisters";
import {
  QUERY_CACHE_BUSTER,
  QUERY_CACHE_MAX_AGE,
} from "@-/dev.improve.haniverse.lib.storage/query-cache-policy";

export function rootQueryClientPersistOptions() {
  return {
    buster: QUERY_CACHE_BUSTER,
    dehydrateOptions: {
      // Static queries persist individually when fetched. Only paused mutations belong
      // in the root snapshot, so startup never hydrates unrelated historical query data.
      shouldDehydrateQuery: () => false,
    },
    maxAge: QUERY_CACHE_MAX_AGE,
    persister: queryCachePersisters().mutationPersister,
  };
}
